import { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";

export default function MainMenuBtn(props) {
  const appContext = useContext(AppContext);

  function openSideBar() {
    appContext.setIsSideBarOpen(true);
  }

  return (
    <div
      className="MainMenuBtn mMobileOnly"
      data-sidebar-open={appContext.isSideBarOpen}
      data-scrolled={appContext.isScrolled}
    >
      {!appContext.isSideBarOpen ? (
        <MdMenu onClick={openSideBar} />
      ) : null}
    </div>
  );
}
